import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { getBillingStatus } from '../auth/authApi';
import Layout from '../components/Layout';

// Landing page after Stripe Checkout. The subscription/org move are applied by the
// webhook, which can lag the browser redirect by a moment, so we poll billing
// status until it lands (with a bounded number of attempts).
const MembershipSuccess = () => {
  const { refreshUser } = useAuth();
  const [state, setState] = useState('pending'); // 'pending' | 'active' | 'timeout'
  const cancelled = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    cancelled.current = false;
    let attempts = 0;
    const maxAttempts = 10;

    const poll = async () => {
      if (cancelled.current) return;
      attempts += 1;
      try {
        const status = await getBillingStatus();
        const active = status && status.subscription &&
          ['active', 'trialing'].includes(status.subscription.status);
        if (active) {
          try { await refreshUser(); } catch (e) {}
          setState('active');
          return;
        }
      } catch (e) { /* keep polling */ }

      if (attempts >= maxAttempts) {
        setState('timeout');
        return;
      }
      setTimeout(poll, 2000);
    };

    poll();
    return () => { cancelled.current = true; };
  }, [refreshUser]);

  const card = {
    maxWidth: "640px",
    margin: "0 auto",
    padding: "40px",
    backgroundColor: "rgba(27, 31, 34, 0.85)",
    borderRadius: "8px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    marginTop: "20px",
    textAlign: "center"
  };
  const button = {
    display: "inline-block",
    marginTop: "20px",
    padding: "12px 28px",
    borderRadius: "6px",
    backgroundColor: "#FF5722",
    color: "#fff",
    textDecoration: "none",
    fontWeight: "600"
  };

  return (
    <Layout>
      <style>{`@keyframes spin {0%{transform:rotate(0)}100%{transform:rotate(360deg)}}`}</style>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: "40px" }}>
          <div style={card}>
            {state === 'pending' && (
              <>
                <div style={{
                  width: "48px", height: "48px", margin: "0 auto 20px",
                  border: "4px solid rgba(255,255,255,0.2)", borderTopColor: "#FF5722",
                  borderRadius: "50%", animation: "spin 0.9s linear infinite"
                }} />
                <h2 className="major">Confirming your access…</h2>
                <p style={{ opacity: 0.9 }}>
                  Payment received. We’re activating your organization access — this only takes a moment.
                </p>
              </>
            )}

            {state === 'active' && (
              <>
                <h2 className="major" style={{ color: "#4CAF50" }}>You’re in! 🎉</h2>
                <p style={{ opacity: 0.9 }}>
                  Your organization access is active. You now have full access — open the app to start training.
                </p>
                <Link to="/portal" style={button}>Back to Portal</Link>
              </>
            )}

            {state === 'timeout' && (
              <>
                <h2 className="major">Almost there…</h2>
                <p style={{ opacity: 0.9 }}>
                  Your payment went through. Your organization access can take a minute to activate — refresh
                  the portal shortly, or contact <a href="mailto:info@rangedrills.io">info@rangedrills.io</a> if
                  it doesn’t appear.
                </p>
                <Link to="/portal" style={button}>Back to Portal</Link>
              </>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default MembershipSuccess;
